document.addEventListener("DOMContentLoaded", function() {
  const items = document.querySelectorAll('.accordion-item');

  items.forEach(item => {
    const title = item.querySelector('.accordion-title');

    title.addEventListener('click', function() {
      // Toggle current
      item.classList.toggle('active');

      // Optional: close others
      items.forEach(i => {
        if (i !== item) {
          i.classList.remove('active');
        }
      });
    });
  });
});
